<lib-generic-list
  #genericList
  [dataProvider]="dataProvider"
  [totalCount]="totalCount"
  [columnsProvider]="columnsProvider"
  [noResultsMessageDisplayKey]="noResultsMessageDisplayKey"
  [itemsPerPageDisplayKey]="itemsPerPageDisplayKey"
  [entriesDisplayKey]="
    totalCount
      ? (genericList.page - 1) * genericList.pageSize +
        1 +
        ' - ' +
        genericList.page * genericList.pageSize +
        ' ' +
        ('of' | translate) +
        ' ' +
        totalCount
      : ''
  "
  [serverPaging]="true"
  [defaultPagination]="false"
  [tableStriped]="false"
  [actionsColumnLeft]="false"
  [rowHeight]="rowHeight"
  [selectable]="true"
  [allSelectable]="allSelectable"
  [expandableRow]="true"
  [defaultRowClick]="false"
  [itemSelectableFunction]="itemSelectableFunction"
  [itemHighlightableFunction]="itemHighlightableFunction"
  (stateChanged)="stateChanged.emit($event)"
>
  <ng-container *libGenericListCustomItemRenderer="'invoiceNumber'; let row">
    <div class="d-flex align-items-center">
      <button class="px-0 mt-1 mt-lg-0 btn btn-link" (click)="genericList.openRowDetails(row)">
        {{ row.invoiceNumber }}
      </button>
    </div>
  </ng-container>
  <ng-container *libGenericListCustomItemRenderer="'detail'; let row">
    <div class="d-flex align-items-center flex-wrap" [ngStyle]="{ height: rowHeight }">
      <img
        *ngIf="(row | showRevenueIcon) && regionCode === 'ANZ'"
        class="icon"
        src="assets/image/LUN2183_Revenue.svg"
      />
      <a [routerLink]="'/promotions'" *ngIf="(row | showRevenueIcon) && regionCode !== 'ANZ'">
        <img class="icon" src="assets/image/LUN2183_Revenue.svg" />
      </a>
      <div
        class="ms-1 w-auto d-flex align-items-center"
        *ngIf="(row | showRevenueIcon) && regionCode !== 'ANZ' && regionCode !== 'NA'"
      >
        {{ currencySymbol }}{{ calculateTotalServiceRevenue(row) | number : '1.2-2' }}
      </div>
      <img
        *ngIf="row | showPointsIcon"
        class="icon"
        src="assets/image/LUN2183_Points.svg"
        [ngClass]="(row | showRevenueIcon) ? 'ms-2' : 'ms-0'"
      />
      <div
        *ngIf="
          (row | showPointsIcon) && (regionCode === 'LAS' || regionCode === 'BR' || regionCode === 'EMEA') && row.sales
        "
        class="ms-1 w-auto d-flex align-items-center"
      >
        {{ calculateTotalSalesPoints(row) }}
      </div>
      <img *ngIf="row | showCreditsIcon" class="ms-2 icon" src="assets/image/LUN2183_Credits.svg" />
    </div>
  </ng-container>
  <ng-container *libGenericListRowDetailsRenderer="''; let row">
    <div class="p-3 d-flex d-sm-none flex-column">
      <ng-container *ngFor="let sale of row.sales">
        <div class="my-2 d-flex flex-column line">
          <div class="d-flex flex-column">
            <ng-container *ngIf="regionCode !== 'EMEA'">
              <strong>{{ 'Product' | translate }}</strong>
              <div>
                {{ sale.description }}<br />
                {{ sale.modelNumber }}
              </div>
            </ng-container>
            <ng-container *ngIf="regionCode === 'EMEA'">
              <strong>{{ 'Part Number' | translate }}</strong>
              <div>
                {{ sale.partNumber ?? sale.modelNumber }}
              </div>
            </ng-container>
          </div>
          <div class="my-2 d-flex flex-column">
            <strong>{{ 'Quantity' | translate }}</strong>
            <div>{{ sale.quantity }}</div>
          </div>
          <div class="my-2 d-flex flex-column">
            <strong>{{ 'LEAP Award' | translate }}</strong>
            <div class="d-flex icons-wrapper">
              <div class="d-flex align-items-center" *ngIf="row.hasServiceRevenue && regionCode !== 'ANZ'">
                <img class="icon" src="assets/image/LUN2183_Revenue.svg" />
                <span class="ms-1">{{ currencySymbol }}{{ calculateTotalServiceRevenue(row) | number : '1.2-2' }}</span>
              </div>
              <div class="d-flex align-items-center" *ngIf="sale.totalPoints > 0">
                <img class="icon" src="assets/image/LUN2183_Points.svg" />
                <span class="ms-1">{{ sale.totalPoints }}</span>
              </div>
              <div class="d-flex align-items-center" *ngIf="sale.credits > 0">
                <img class="icon" src="assets/image/LUN2183_Credits.svg" />
                <span class="ms-1">{{ sale.credits }}</span>
              </div>
            </div>
          </div>
          <div class="my-2 d-flex flex-column" *ngIf="regionCode === 'ANZ'">
            <ng-container *ngIf="row.hasServiceRevenue">
              <strong>{{ getANZRevenueLabel(row) | translate }}</strong>
              <div>
                <img class="icon" src="assets/image/LUN2183_Revenue.svg" />
                <span class="ms-1" *ngIf="sale.isgServiceRevenue > 0">{{ sale.isgServiceRevenue | currency }}</span>
                <span class="ms-1" *ngIf="sale.idgServiceRevenue > 0">{{ sale.idgServiceRevenue | currency }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="row.hasServicePoints">
              <strong>{{ getANZPointsLabel(row) | translate }}</strong>
              <div>
                <img class="icon" src="assets/image/LUN2183_Points.svg" />
                <span class="ms-1" *ngIf="sale.idgServicePoints > 0">{{ sale.idgServicePoints }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <hr class="my-2" />
      </ng-container>
    </div>
    <div class="d-none d-sm-flex flex-column row-details">
      <div class="d-flex my-2 line">
        <div>
          <ng-container *ngIf="regionCode !== 'EMEA'">
            <strong>{{ 'Product' | translate }}</strong>
          </ng-container>
          <ng-container *ngIf="regionCode === 'EMEA'">
            <strong>{{ 'Part Number' | translate }}</strong>
          </ng-container>
        </div>
        <div>
          <strong>{{ 'Quantity' | translate }}</strong>
        </div>
        <div [ngClass]="regionCode !== 'ANZ' ? 'last-row' : 'third-row'">
          <strong>{{ 'LEAP Award' | translate }}</strong>
        </div>
        <div class="ms-auto pe-4" *ngIf="regionCode === 'ANZ'">
          <strong *ngIf="row.hasServiceRevenue">{{ getANZRevenueLabel(row) | translate }}</strong>
          <strong *ngIf="row.hasServicePoints">{{ getANZPointsLabel(row) | translate }}</strong>
        </div>
      </div>
      <ng-container *ngFor="let sale of row.sales">
        <hr class="my-2" />
        <div class="d-flex line">
          <ng-container *ngIf="regionCode !== 'EMEA'">
            <div>
              {{ sale.description }}<br />
              {{ sale.modelNumber }}
            </div>
          </ng-container>
          <ng-container *ngIf="regionCode === 'EMEA'">
            <div>
              {{ sale.partNumber ?? sale.modelNumber }}
            </div>
          </ng-container>
          <div>{{ sale.quantity }}</div>
          <div class="d-flex icons-wrapper" [ngClass]="regionCode !== 'ANZ' ? 'last-row' : 'third-row'">
            <div class="d-flex align-items-center" *ngIf="row.hasServiceRevenue && regionCode !== 'ANZ'">
              <img class="icon" src="assets/image/LUN2183_Revenue.svg" />
              <span class="ms-1">{{ currencySymbol }}{{ calculateTotalServiceRevenue(row) | number : '1.2-2' }}</span>
            </div>
            <div class="d-flex align-items-center" *ngIf="sale.totalPoints > 0">
              <img class="icon" src="assets/image/LUN2183_Points.svg" />
              <span class="ms-1">{{ sale.totalPoints }}</span>
            </div>
            <div class="d-flex align-items-center" *ngIf="sale.credits > 0">
              <img class="icon" src="assets/image/LUN2183_Credits.svg" />
              <span class="ms-1">{{ sale.credits }}</span>
            </div>
          </div>
          <div class="ms-auto pe-4 d-flex align-items-center" *ngIf="regionCode === 'ANZ'">
            <ng-container *ngIf="row.hasServiceRevenue">
              <div>
                <img class="icon" src="assets/image/LUN2183_Revenue.svg" />
                <span class="ms-1" *ngIf="sale.isgServiceRevenue > 0">{{ sale.isgServiceRevenue | currency }}</span>
                <span class="ms-1" *ngIf="sale.idgServiceRevenue > 0">{{ sale.idgServiceRevenue | currency }}</span>
              </div>
            </ng-container>
            <ng-container *ngIf="row.hasServicePoints">
              <div>
                <img class="icon" src="assets/image/LUN2183_Points.svg" />
                <span class="ms-1" *ngIf="sale.idgServicePoints > 0">{{ sale.idgServicePoints }}</span>
              </div>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</lib-generic-list>
